{
  "COMPOSE_REDIRECT": {
    "OPENING": "Otvaranje novog razgovora sa {email}…",
    "NO_EMAIL": "Adresa e-pošte nije navedena. Koristite ?email=name@example.com",
    "CONTACT_ERROR": "Nije moguće pronaći kontakt za {email}."
  },
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Izaberite razgovor sa leve strane",
    "CSAT_REPLY_MESSAGE": "Molim vas ocenite ovaj razgovor",
    "404": "Izvinite, ne možemo da pronađemo razgovor. Molim vas pokušajte ponovo",
    "SWITCH_VIEW_LAYOUT": "Promeni raspored",
    "DASHBOARD_APP_TAB_MESSAGES": "Poruke",
    "UNVERIFIED_SESSION": "Identitet korisnika nije potvrđen",
    "NO_MESSAGE_1": "O ne! Izgleda da nema poruka od korisnika u vašem prijemnom sandučetu.",
    "NO_MESSAGE_2": " poslati poruku tvojoj stranici!",
    "NO_INBOX_1": "Pozdrav! Izgleda da još uvek niste dodali prijemno sanduče.",
    "NO_INBOX_2": " da bi ste počeli",
    "NO_INBOX_AGENT": "O ne! Izgleda da niste deo nijednog prijemnog sandučeta. Molim vas kontaktirajte vašeg administratora",
    "SEARCH_MESSAGES": "Pretražite poruke u razgovorima",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Превод",
    "EMPTY_STATE": {
      "CMD_BAR": "to open command menu",
      "KEYBOARD_SHORTCUTS": "to view keyboard shortcuts"
    },
    "SEARCH": {
      "TITLE": "Pretraži poruke",
      "RESULT_TITLE": "Rezultat pretrage",
      "LOADING_MESSAGE": "Obrada podataka...",
      "PLACEHOLDER": "Upišite bilo koji tekst da bi ste pretražili poruke",
      "NO_MATCHING_RESULTS": "Ništa nije pronađeno."
    },
    "UNREAD_MESSAGES": "Nepročitane poruke",
    "UNREAD_MESSAGE": "Nepročitana poruka",
    "CLICK_HERE": "Kliknite ovde",
    "LOADING_INBOXES": "Učitavanje prijemnih sandučića",
    "LOADING_CONVERSATIONS": "Učitavanje razgovora",
    "CANNOT_REPLY": "Ne možete da odgovorite zbog",
    "24_HOURS_WINDOW": "24-časovno ograničenje poruka",
    "NOT_ASSIGNED_TO_YOU": "Ovaj razgovor nije dodeljen vama. Da li želite da dodelite razgovor sebi?",
    "ASSIGN_TO_ME": "Dodeli meni",
    "TWILIO_WHATSAPP_CAN_REPLY": "Možete jedino da odgovarate na ovaj razgovor koristeći šablon poruka zbog",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24-časovno ograničenje poruka",
    "REPLYING_TO": "Odgovarate na:",
    "REMOVE_SELECTION": "Ukloni izbor",
    "DOWNLOAD": "Preuzmi",
    "UNKNOWN_FILE_TYPE": "Nepoznata datoteka",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Pre slanja izvršite:",
      "EXECUTE": "Izvrši",
      "RETRY": "Pokušajte ponovo",
      "CONFIRM": "Izvršiti sada?",
      "CONFIRM_YES": "Da, izvrši",
      "CONFIRM_NO": "Otkaži",
      "RUNNING": "U toku…",
      "DONE": "Izvršeno",
      "CLAIM_DELAYED": "biće podneta nakon isporuke porudžbine",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "Podneta NOVA reklamacija {reference}, {planned} je zatvorena — izmenite tekst nacrta",
        "NEW_CLAIM": "Podneta NOVA reklamacija {reference} umesto dopune {planned} — izmenite tekst nacrta",
        "OTHER_CLAIM": "Dopunjena reklamacija {reference} umesto {planned} — izmenite tekst nacrta",
        "EXISTING_CLAIM": "Nova reklamacija nije podneta, dopunjena je postojeća {reference} — izmenite tekst nacrta",
        "OTHER": "Prošlo je drugačije nego što je nacrt pretpostavljao — izmenite tekst nacrta"
      },
      "FAILED": "Nije uspelo",
      "UNREACHABLE": "Bot nije dostupan",
      "REQUEST_FAILED": "Radnju nije bilo moguće pokrenuti, pokušajte ponovo.",
      "ACTIONS": {
        "CANCEL_ORDER": "Otkažite porudžbinu",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Promenite način plaćanja na pouzeće",
        "CREATE_CLAIM": "Podnesite reklamaciju",
        "CREATE_OR_UPDATE_CLAIM": "Podnesite ili ažurirajte reklamaciju",
        "EXTEND_ORDER_PICKUP_DATE": "Produžite rok za preuzimanje"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Dodavanje priloga...",
    "REPLIED_TO_STORY": "Replied to your story",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "This message is unsupported. You can view this message on the Facebook Messenger app.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "This message is unsupported. You can view this message on the Instagram app.",
    "SUCCESS_DELETE_MESSAGE": "Poruka je uspešno obrisana",
    "FAIL_DELETE_MESSSAGE": "Nije bilo moguće obrisati poruku! Pokušajte ponovo",
    "NO_RESPONSE": "Nema odgovora",
    "RESPONSE": "Response",
    "RATING_TITLE": "Ocena",
    "FEEDBACK_TITLE": "Povratne informacije",
    "REPLY_MESSAGE_NOT_FOUND": "Message not available",
    "CARD": {
      "SHOW_LABELS": "Show labels",
      "HIDE_LABELS": "Hide labels"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Reši",
      "REOPEN_ACTION": "Ponovo otvori",
      "OPEN_ACTION": "Otvoreni",
      "OPEN": "Više",
      "CLOSE": "Zatvori",
      "DETAILS": "detalji",
      "SNOOZED_UNTIL": "Snoozed until",
      "SNOOZED_UNTIL_TOMORROW": "Odloženo do sutra",
      "SNOOZED_UNTIL_NEXT_WEEK": "Odloženo do sledeće nedelje",
      "SNOOZED_UNTIL_NEXT_REPLY": "Odloženo do sledećeg odgovora",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      },
      "MORE": "More actions"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Označeno na čekanju",
      "SNOOZE_UNTIL": "Odloži",
      "SNOOZE": {
        "TITLE": "Odloži do",
        "NEXT_REPLY": "Sledećeg odgovora",
        "TOMORROW": "Sutra",
        "NEXT_WEEK": "Sledeće nedelje"
      },
      "RESOLVE_WITHOUT_CSAT": "Resolve without CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Odloži do",
      "APPLY": "Odloži",
      "CANCEL": "Otkaži"
    },
    "PRIORITY": {
      "TITLE": "Priority",
      "OPTIONS": {
        "NONE": "Niko",
        "URGENT": "Hitno",
        "HIGH": "Visok",
        "MEDIUM": "Srednji",
        "LOW": "Nizak"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Niko",
        "INPUT_PLACEHOLDER": "Select priority",
        "NO_RESULTS": "Ništa nije pronađeno",
        "SUCCESSFUL": "Changed priority of conversation id {conversationId} to {priority}",
        "FAILED": "Couldn't change priority. Please try again."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Otvori u novoj kartici",
      "COPY_LINK": "Kopiraj link do razgovora",
      "COPY_LINK_SUCCESS": "Link do razgovora je kopiran u privremenu memoriju",
      "PENDING": "Označeno na čekanju",
      "RESOLVED": "Označi kao rešeno",
      "MARK_AS_UNREAD": "Mark as unread",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Ponovo otvori razgovor",
      "SNOOZE": {
        "TITLE": "Odloži",
        "NEXT_REPLY": "Do sledećeg odgovora",
        "TOMORROW": "Do sutra",
        "NEXT_WEEK": "Do sledeće nedelje"
      },
      "ASSIGN_AGENT": "Dodeli agenta",
      "ASSIGN_LABEL": "Dodeli oznaku",
      "AGENTS_LOADING": "Učitavanje agenata...",
      "ASSIGN_TEAM": "Dodeli tim",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Razgovor sa ID {conversationId} je dodeljen \"{agentName}\"",
          "FAILED": "Nije bilo moguće dodeliti agenta. Molim vas pokušajte ponovo."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Nije bilo moguće dodeliti oznaku. Molim vas pokušajte ponovo."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Dodeljen je tim \"{team}\" razgovoru sa id {conversationId}",
          "FAILED": "Nije bilo moguće dodeliti tim. Molim vas pokušajte ponovo."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Potpis poruke",
      "ENABLE_SIGN_TOOLTIP": "Omogući potpis",
      "DISABLE_SIGN_TOOLTIP": "Onemogući potpis",
      "MSG_INPUT": "Shift + enter za novi red. Počni sa '/' da bi ste izabrali brzi odgovor.",
      "PRIVATE_MSG_INPUT": "Shift + enter za novi red. Ovo će biti vidljivo samo agentima",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Potpis poruke nije podešen, molim vas podesite ga u podešavanjima profila.",
      "CLICK_HERE": "Kliknite ovde da izmenite",
      "WHATSAPP_TEMPLATES": "Whatsapp šabloni",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "24-satni WhatsApp prozor je istekao. Odgovorite šablonskom porukom.",
      "INSERT_SIGNATURE": "Insert signature into editor",
      "SIGNATURE_PREVIEW_IMAGE": "(image signature)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Изгледа да је ваш одговор на {draftLanguage}, али овај разговор је на {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Преведи",
      "REPLY": "Odgovor",
      "PRIVATE_NOTE": "Privatna beleška",
      "SEND": "Pošalji",
      "CREATE": "Dodaj belešku",
      "INSERT_READ_MORE": "Read more",
      "DISMISS_REPLY": "Dismiss reply",
      "REPLYING_TO": "Replying to:",
      "TIP_FORMAT_ICON": "Prikaži bogat uređivač teksta",
      "HEADING_LEVEL": {
        "LABEL": "Stil teksta",
        "NORMAL": "Običan tekst",
        "H1": "Naslov 1",
        "H2": "Naslov 2",
        "H3": "Naslov 3"
      },
      "EDITOR": {
        "BOLD": "Podebljano",
        "ITALIC": "Kurziv",
        "UNDERLINE": "Podvučeno",
        "TEXT_COLOR": "Boja teksta",
        "BG_COLOR_LABEL": "Boja pozadine",
        "FONT_SIZE_LABEL": "Veličina fonta",
        "FONT_SIZE": {
          "XS": "Malo",
          "SM": "Srednje malo",
          "MD": "Podrazumevano",
          "LG": "Veliko",
          "XL": "Vrlo veliko",
          "XXL": "Ogromno"
        },
        "CODE": "Kod",
        "LINK": "Dodaj ili ukloni link",
        "CREATE_LINK": "Kreiraj link",
        "SAVE_LINK": "Sačuvaj",
        "CANCEL": "Otkaži",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Opozovi",
        "REDO": "Ponovi",
        "BULLET_LIST": "Lista sa tačkama",
        "ORDERED_LIST": "Numerisana lista",
        "BLOCKQUOTE": "Citat",
        "H1": "Naslov 1",
        "H2": "Naslov 2",
        "H3": "Naslov 3",
        "IMAGE_UPLOAD": "Otpremi sliku",
        "CLEAR_FORMATTING": "Očisti formatiranje",
        "COLOR": {
          "RED": "Crvena",
          "YELLOW": "Žuta",
          "BLUE": "Plava",
          "ROSE_RED": "Ružičasto crvena",
          "DEEP_CYAN": "Tamno cijan",
          "ORANGE": "Narandžasta",
          "PISTACHIO": "Pistaći zelena",
          "PURPLE": "Ljubičasta",
          "FUCHSIA": "Fuksija",
          "SILVER": "Srebrna",
          "NAVY": "Mornarsko plava",
          "OLD_PINK": "Stara roze",
          "AQUA": "Akva",
          "BROWN": "Braon",
          "OLIVE": "Maslinasta",
          "GOLD": "Zlatna",
          "BEIGE": "Bež",
          "WINE": "Vinska",
          "FOREST": "Šumsko zelena",
          "GREEN": "Zelena",
          "BLUE_GREY": "Plavo-siva",
          "RUBY_RED": "Rubin crvena",
          "CHESTNUT_BROWN": "Kestenjasto braon",
          "ASH_GREY": "Pepeljasto siva"
        },
        "BG_COLOR": {
          "RED": "Crvena",
          "YELLOW": "Žuta",
          "BLUE": "Plava",
          "ROSE_RED": "Ružičasto crvena",
          "DEEP_CYAN": "Tamno cijan",
          "ORANGE": "Narandžasta",
          "PISTACHIO": "Pistaći zelena",
          "PURPLE": "Ljubičasta",
          "FUCHSIA": "Fuksija",
          "SILVER": "Srebrna",
          "NAVY": "Mornarsko plava",
          "OLD_PINK": "Stara roze",
          "AQUA": "Akva",
          "BROWN": "Braon",
          "OLIVE": "Maslinasta",
          "GOLD": "Zlatna",
          "BEIGE": "Bež",
          "WINE": "Vinska",
          "FOREST": "Šumsko zelena",
          "GREEN": "Zelena",
          "BLUE_GREY": "Plavo-siva",
          "RUBY_RED": "Rubin crvena",
          "CHESTNUT_BROWN": "Kestenjasto braon",
          "ASH_GREY": "Pepeljasto siva"
        }
      },
      "TIP_EMOJI_ICON": "Prikaži birač emotikona",
      "TIP_ATTACH_ICON": "Dodaj datoteke",
      "TIP_AUDIORECORDER_ICON": "Snimi zvuk",
      "TIP_AUDIORECORDER_PERMISSION": "Dozvoli pristup zvuku",
      "TIP_AUDIORECORDER_ERROR": "Nije moguće pristupiti zvuku",
      "DRAG_DROP": "Prevuci i pusti za dodavanje",
      "START_AUDIO_RECORDING": "Pokreni snimanje zvuka",
      "STOP_AUDIO_RECORDING": "Zaustavi snimanje zvuka",
      "": "",
      "EMAIL_HEAD": {
        "TO": "TO",
        "ADD_BCC": "Dodaj bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "E-pošte odvojene zarezima",
          "ERROR": "Molim vas unesite ispravne adrese e-pošte"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "E-pošte odvojene zarezima",
          "ERROR": "Molim vas unesite ispravne adrese e-pošte"
        },
        "EDIT": "Edit",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Hide",
        "INCLUDE_ORIGINAL_MESSAGE": "Include original message",
        "EDIT_HEADERS": "Edit",
        "HIDE_HEADER_EDITS": "Hide edits",
        "SUBJECT": {
          "LABEL": "SUBJECT",
          "PLACEHOLDER": "Email subject",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Undefined variables",
        "MESSAGE": "You have {undefinedVariablesCount} undefined variables in your message: {undefinedVariables}. Would you like to send the message anyway?",
        "CONFIRM": {
          "YES": "Pošalji",
          "CANCEL": "Otkaži"
        }
      },
      "SEND_EMAIL": "Send email",
      "SEND_SMS": "Send SMS",
      "NO_SMS_INBOX": "Dodajte SMS sanduče da biste slali SMS odgovore.",
      "SEND_CHAT": "Send chat",
      "REPLY_TO_THIS": "Reply to this",
      "TIP_EXPAND_ICON": "Enlarge editor",
      "TIP_COLLAPSE_ICON": "Shrink editor",
      "COPILOT": {
        "Q": "Ask robot for help"
      }
    },
    "VISIBLE_TO_AGENTS": "Privatna beleška: Vidljiva samo vama i vašem timu",
    "CHANGE_STATUS": "Status razgovora je izmenjen",
    "CHANGE_STATUS_FAILED": "Nije uspela izmena statusa razgovora",
    "CHANGE_AGENT": "Izmenjen je dodeljen razgovoru",
    "CHANGE_AGENT_FAILED": "Nije uspela izmena dodeljenog",
    "ASSIGN_LABEL_SUCCESFUL": "Oznaka je uspešno dodeljena",
    "ASSIGN_LABEL_FAILED": "Nije uspela dodela oznake",
    "CHANGE_TEAM": "Tim razgovora je promenjen",
    "FILE_SIZE_LIMIT": "File exceeds the {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB attachment limit",
    "MESSAGE_ERROR": "Nije moguće slanje poruke, molim vas pokušajte ponovo",
    "SENT_BY": "Poslao:",
    "BOT": "Bot",
    "SEND_FAILED": "Nije bilo moguće poslati poruku! Pokušajte ponovo",
    "TRY_AGAIN": "pokušaj ponovo",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Izaberi agenta",
      "REMOVE": "Ukloni",
      "ASSIGN": "Dodeli"
    },
    "CONTEXT_MENU": {
      "COPY": "Kopiraj",
      "REPLY_TO": "Reply to this message",
      "DELETE": "Izbriši",
      "CREATE_A_CANNED_RESPONSE": "Add to canned responses",
      "TRANSLATE": "Prevedi",
      "COPY_PERMALINK": "Copy link to the message",
      "LINK_COPIED": "Message URL copied to the clipboard",
      "DELETE_CONFIRMATION": {
        "TITLE": "Are you sure you want to delete this message?",
        "MESSAGE": "You cannot undo this action",
        "DELETE": "Izbriši",
        "CANCEL": "Otkaži"
      },
      "FORWARD": "Foward",
      "FORWARD_ERROR": "Failed to prepare forwarded message"
    },
    "SIDEBAR": {
      "CONTACT": "Kontakt",
      "COPILOT": "Copilot"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Razgovor je označen kao rešen od strane {userName}",
          "CONTACT_RESOLVED": "Razgovor je rešen od strane {contactName}",
          "OPEN": "Razgovor je ponovo otvoren od strane {userName}",
          "PENDING": "Razgovor je označen kao na čekanju od strane {userName}",
          "SNOOZED": "Razgovor je odložen od strane {userName}",
          "AUTO_RESOLVED": "Razgovor je označen kao rešen od strane sistema zbog {duration} dana neaktivnosti",
          "SYSTEM_AUTO_OPEN": "System reopened the conversation due to a new incoming message.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversation was marked resolved by {userName} (without CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversation was marked resolved by system due to {duration} hours of inactivity",
          "AUTO_RESOLVED_EMPTY": "Conversation was marked resolved by system due to being empty.",
          "BLOCKED_CONTACT_RESOLVED": "System resolved the conversation because the contact is blocked.",
          "KAUFLAND_TICKET_CLOSED": "Sistem je označio razgovor kao rešen jer je tiket zatvoren na Kauflandu."
        },
        "PRIORITY": {
          "ADDED": "{userName} set the priority to {newPriority}",
          "UPDATED": "{userName} changed the priority from {oldPriority} to {newPriority}",
          "REMOVED": "{userName} removed the priority"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} je samododelio sebe ovom razgovoru",
          "ASSIGNED": "Dodeljeno {assigneeName} od strane {userName}",
          "REMOVED": "Razgovoru uklonjena dodela od strane {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Dodeljeno {teamName} od strane {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Dodeljeno {assigneeName} putem {teamName} od strane {userName}",
          "REMOVED": "Uklonjena dodela {teamName} od strane {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} je dodao {labels}",
          "REMOVED": "{userName} je uklonio {labels}"
        },
        "SLA": {
          "ADDED": "{userName} added SLA policy {slaName}",
          "REMOVED": "{userName} removed SLA policy {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} je utišao razgovor",
        "UNMUTED": "{userName} je uklonio utišanje razgovora",
        "CONTACT_BLOCKED": "{userName} је блокирао/ла контакт",
        "CONTACT_UNBLOCKED": "{userName} је одблокирао/ла контакт",
        "AUTO_RESOLUTION_MESSAGE": "Resolving the conversation as it has been inactive for a while. Please start a new conversation if you need further assistance.",
        "DOMAIN_BLOCKED": "{userName} blocked all contacts for a given domain",
        "DOMAIN_UNBLOCKED": "{userName} unblocked all the contacts for a given domain",
        "MOVED": "{userName} moved this conversation from inbox {sourceInboxName} to inbox {targetInboxName}",
        "MOVED_BY_ORDER": "Premešteno jer porudžbine kontakta dolaze samo iz prodavnice {storeName} (poslednja porudžbina {orderId}), čiji robot odgovara u ovom prijemnom sandučetu.",
        "MERGED": "{userName} merged conversation #{sourceId} into this conversation",
        "AUTOMATION_RULE_TRIGGERED": "Automation rule \"{ruleName}\" triggered",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automation rule \"{ruleName}\" disabled automatic priority",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automation rule \"{ruleName}\" disabled automatic labeling",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automation rule \"{ruleName}\" stopped further rule processing",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Sending message action was skipped for this auto-reply message",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Аутоматизација је прескочена јер је контакт блокиран",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Automatizacija \"{ruleName}\" nije mogla da premesti ovaj razgovor iz sandučića {sourceInboxName} u sandučić {targetInboxName} jer sandučići nisu kompatibilni.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Automatizacija \"{ruleName}\" nije mogla da premesti ovaj razgovor iz sandučića {sourceInboxName} u sandučić {targetInboxName} jer kontakt nema adresu e-pošte.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Automatizacija \"{ruleName}\" nije mogla da pošalje poruku: ovo telefonsko prijemno sanduče ne može da šalje SMS jer nalog nema SMS prijemno sanduče. Pravilo je isključeno, a administratori su dobili e-poštu.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Automatizacija \"{ruleName}\" nije mogla da pošalje poruku: iz ovog prijemnog sandučeta nije moguće slati priloge preko SMS-a. Pravilo je isključeno, a administratori su dobili e-poštu.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Makro \"{macroName}\" nije poslao poruku: ovo telefonsko prijemno sanduče ne može da šalje SMS jer nalog nema SMS prijemno sanduče.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Makro \"{macroName}\" nije poslao poruku: iz ovog prijemnog sandučeta nije moguće slati priloge preko SMS-a.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Makro \"{macroName}\" nije poslao poruku: ovaj razgovor obrađuje bot. Prvo otvorite razgovor.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Makro \"{macroName}\" nije poslao poruku: ovo sanduče je označeno za brisanje. Prvo premestite razgovor u drugo sanduče.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Automatizacija \"{ruleName}\" je poslala e-poruku na {contactEmail} u novom razgovoru [#{conversationId}]({conversationPath}) u sandučiću {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Automatizacija \"{ruleName}\" je započela ovaj razgovor zbog razgovora [#{conversationId}]({conversationPath}) u sandučiću {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Automatizacija \"{ruleName}\" nije mogla da pošalje poruku u novom razgovoru u sandučiću {inboxName} jer kontakt nema adresu e-pošte.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Automatizacija \"{ruleName}\" je poslala SMS na {contactPhone} u novom razgovoru [#{conversationId}]({conversationPath}) u sandučiću {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Automatizacija \"{ruleName}\" nije mogla da pošalje SMS u novom razgovoru u sandučiću {inboxName} jer kontakt nema broj telefona.",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Агент",
            "CUSTOMER": "Клијент"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "odgovoreno na drugom mestu, zvonilo {duration}",
            "NO_ANSWER": "nije odgovoreno, zvonilo {duration}",
            "REJECTED": "odbijeno, zvonilo {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Automatski rešeno nakon neuspešnih povratnih poziva (broj: {count})",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Snimak poziva obrisan je od strane korisnika {name}, {date}"
        }
      }
    },
    "IMAGE_RESIZE": {
      "SMALL": "Small",
      "MEDIUM": "Medium",
      "LARGE": "Large",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Show hidden messages",
    "TRANSCRIPT": {
      "SHOW": "Show full transcript",
      "HIDE": "Hide full transcript",
      "DOWNLOAD": "Download transcript",
      "COPY": "Copy transcript"
    },
    "INVISIBLE_TO_CUSTOMER": "Невидљиво за клијента",
    "SENT_VIA_EMAIL": "Poslato kontaktu i putem e-pošte ({time})",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "FACEBOOK_CANNOT_REPLY": "If you need to continue this conversation, ",
    "PENDING_WITH_BOT_BANNER": "This conversation is being handled by AI bot. If you want to reply, open the conversation first.",
    "INBOX_DELETE_REQUESTED_BANNER": "Ovo sanduče je označeno za brisanje, pa odgovor klijenta nikada ne bi stigao. Da biste odgovorili, premestite razgovor u drugo sanduče.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Ovaj kontakt ima još jedan otvoreni razgovor #{id}",
      "MULTIPLE": "Ovaj kontakt ima druge otvorene razgovore ({count})",
      "OPEN": "Otvori",
      "SHOW": "Prikaži"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won't be able to send messages from this conversation anymore.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Cannot send message because the customer is not online and email continuity is not available.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "The customer is not online. They may not receive messages since email continuity is not available.",
    "OPEN_FILE": "Open",
    "DOWNLOAD_ATTACHMENTS": "Download all",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Download all attachments one by one",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Download all as ZIP",
    "ERROR_DOWNLOADING_FILE": "Error downloading file",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Zamoli korisnika da podeli svoj WhatsApp broj telefona",
      "PENDING_ACTION": "Zahtev za informacijama o kontaktu je na čekanju",
      "STATES": {
        "PENDING": "Čekaju se informacije o kontaktu",
        "SHARED": "Broj telefona je podeljen",
        "IDENTITY_CONFLICT": "Broj telefona treba proveriti"
      }
    },
    "SLA": {
      "BREACHED": "breached"
    },
    "IMAGE_UPLOAD_ERROR": "Unable to upload image, please try again",
    "DRAFT": {
      "FILE_TOO_LARGE": "File '{fileName}' ({fileSize}) is too large for draft storage and will be skipped",
      "ATTACHMENT_SERIALIZATION_FAILED": "Failed to serialize attachment for draft storage",
      "STORAGE_QUOTA_EXCEEDED": "Storage quota exceeded. Draft saved without attachments",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Failed to save draft even without attachments",
      "SAVE_FAILED": "Failed to save conversation draft"
    },
    "COMMENT_TREE": {
      "TITLE": "Comment thread",
      "EMPTY": "No comments to display",
      "VIEW_TREE": "View comment thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Pošalji transkript razgovora",
    "DESC": "Pošaljite kopiju transkripta razgovora na određenu adresu e-pošte",
    "SUBMIT": "Pošalji",
    "CANCEL": "Otkaži",
    "SEND_EMAIL_SUCCESS": "Transkript razgovora je uspešno poslat",
    "SEND_EMAIL_ERROR": "Pojavila se greška, molim vas pokušajte ponovo",
    "FORM": {
      "SEND_TO_CONTACT": "Pošaljite transkript potrošaču",
      "SEND_TO_AGENT": "Pošaljite transkript dodeljenom agentu",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Pošaljite transkript još jednoj adresi e-pošte",
      "EMAIL": {
        "PLACEHOLDER": "Unesite adresu e-pošte",
        "ERROR": "Molim vas unesite ispravnu adresu e-pošte"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Zdravo 👋, Dobrodošli u {installationName}!",
    "DESCRIPTION": "Hvala vam na registraciji. Želimo da najbolje iskoristite ovu {installationName}. Evo nekoliko stvari koje možete da uradite u {installationName} da bi vaše iskustvo bilo izvrsno.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Pročitajte naše najnovije izmene",
    "ALL_CONVERSATION": {
      "TITLE": "Svi vaši razgovori na jednom mestu",
      "DESCRIPTION": "Pregledajte sve razgovore sa vašim kupcima u jednoj radnoj tabli. Možete filtrirati razgovore prema dolaznom kanalu, oznaci i statusu.",
      "NEW_LINK": "Kliknite ovde da napravite prijemno sanduče"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Pozovite članove vašeg tima",
      "DESCRIPTION": "Sobzirom da se spremate da razgovarate sa vašim potrošačima, dovedite članove vašeg time da vam pomognu. Možete pozvati članove vašeg time dodavanjem njihove adrese e-pošte u spisak agenata.",
      "NEW_LINK": "Kliknite ovde da pozovete člana tima"
    },
    "LABELS": {
      "TITLE": "Organizujte razgovore sa oznakama",
      "DESCRIPTION": "Oznake omogućavaju lakši način da se kategorišu razgovori. Napravite oznake poput #upit-podrske, #pitanje-placanja itd., kako bi ste ih koristili u kasnijim razgovorima.",
      "NEW_LINK": "Kliknite ovde da napravite oznake"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Dodeljeni agent",
    "SELF_ASSIGN": "Dodeli meni",
    "TEAM_LABEL": "Dodeljeni tim",
    "SELECT": {
      "PLACEHOLDER": "Niko"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Custom Data",
      "CONTACT_DETAILS": "Detalji o kontaktu",
      "CONVERSATION_ACTIONS": "Akcije nad razgovorom",
      "CONVERSATION_LABELS": "Oznake razgovora",
      "CONVERSATION_INFO": "Informacije o razgovoru",
      "CONTACT_ATTRIBUTES": "Atributi kontakta",
      "PREVIOUS_CONVERSATION": "Prethodni razgovor",
      "MACROS": "Macros",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Order History",
      "RETINO_TICKETS": "Retino Tickets"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Nerešen",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Napravi atribut",
    "NO_RECORDS_FOUND": "Nijedan atribut nije pronađen",
    "UPDATE": {
      "SUCCESS": "Atribut je uspešno izmenjen",
      "ERROR": "Nije bilo moguće izmeniti atribut. Molim vas pokušajte ponovo"
    },
    "ADD": {
      "TITLE": "Dodaj",
      "SUCCESS": "Atribut je uspešno dodat",
      "ERROR": "Nije bilo moguće dodati atribut. Molim vas pokušajte ponovo"
    },
    "DELETE": {
      "SUCCESS": "Atribut je uspešno obrisan",
      "ERROR": "Nije bilo moguće obrisati atribut. Molim vas pokušajte ponovo"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Dodaj atribute",
      "PLACEHOLDER": "Traži atribute",
      "NO_RESULT": "Nijedan atribut nije pronađen"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Od",
    "TO": "Za",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Naslov"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participating",
    "SIDEBAR_TITLE": "Conversation participants",
    "NO_RECORDS_FOUND": "Ništa nije pronađeno",
    "ADD_PARTICIPANTS": "Select participants",
    "REMANING_PARTICIPANTS_TEXT": "+{count} others",
    "REMANING_PARTICIPANT_TEXT": "+{count} other",
    "TOTAL_PARTICIPANTS_TEXT": "{count} people are participating.",
    "TOTAL_PARTICIPANT_TEXT": "{count} person is participating.",
    "NO_PARTICIPANTS_TEXT": "No one is participating!.",
    "WATCH_CONVERSATION": "Join conversation",
    "YOU_ARE_WATCHING": "You are participating",
    "API": {
      "ERROR_MESSAGE": "Could not update, try again!",
      "SUCCESS_MESSAGE": "Participants updated!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "View translated content",
    "DESC": "You can view the translated content in each langauge.",
    "ORIGINAL_CONTENT": "Original Content",
    "TRANSLATED_CONTENT": "Translated Content",
    "NO_TRANSLATIONS_AVAILABLE": "No translations are available for this content"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Someone is typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No data found",
    "LOAD_ERROR": "Unable to load data. Please try again later."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Load more",
    "NO_RECORDS_FOUND": "No tickets found",
    "LOAD_ERROR": "Unable to load tickets from {hookName}. Please try again later.",
    "NOT_SEARCHABLE": "Contact email is not set.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Loading...",
    "NO_ORDERS": "No orders found",
    "NOT_AVAILABLE": "Customer data not available",
    "EXPAND": "Open customer profile",
    "MORE_ITEMS": "+ {count} items",
    "EXPEDITION_STATUS": "Expedition status",
    "OPEN_DETAIL": "open detail",
    "COPY_ORDER_ID": "Broj porudžbine",
    "EXTERNAL_ID": "Spoljni ID",
    "PAYMENT_TYPE": "Način plaćanja",
    "PAYMENT_DATE": "Datum plaćanja",
    "DELIVERY_PROVIDER": "Dostavljač",
    "EXPECTED_DATE_OF_DELIVERY": "Očekivana isporuka",
    "DATE_OF_DELIVERY": "Isporučeno",
    "EXPEDITION_DATE": "Datum otpreme",
    "INTERNAL_NOTE": "Napomena prodavnice",
    "PACKAGE_NUMBER": "Pošiljka"
  },
  "READING": {
    "ONE": "{user} is reading this ticket",
    "TWO": "{user} and {secondUser} are reading this ticket",
    "MULTIPLE": "{user} and {count} others are reading this ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Move Conversation",
    "DESCRIPTION": "Move this conversation to a different email inbox.",
    "SOURCE": {
      "TITLE": "Conversation",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Destination Inbox",
      "PLACEHOLDER": "Select an email inbox",
      "NO_RESULTS": "No other email inboxes available",
      "ERROR": "Please select a destination inbox"
    },
    "SUBMIT": "Move Conversation",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation moved successfully",
    "ERROR_MESSAGE": "Could not move conversation. Please try again."
  },
  "MERGE": {
    "TITLE": "Merge Conversations",
    "DESCRIPTION": "Merge this conversation with another conversation. All messages from this conversation will be moved to the target conversation, and this conversation will be deleted.",
    "SOURCE": {
      "TITLE": "Source Conversation (will be deleted)",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Target Conversation",
      "PLACEHOLDER": "Type conversation ID to search (e.g., 123)",
      "HELP": "Enter the conversation ID to merge all messages into.",
      "ERROR": "Please select a target conversation"
    },
    "WARNING": "Warning: This action cannot be undone. All messages will be moved to the target conversation and this conversation will be permanently deleted.",
    "SUBMIT": "Merge Conversations",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation merged successfully",
    "ERROR_MESSAGE": "Could not merge conversations. Please check the target conversation and try again.",
    "SEARCH": {
      "NO_RESULTS": "No conversation found with this ID",
      "ERROR_MESSAGE": "Could not search conversations. Please try again."
    },
    "CONFIRM": {
      "TITLE": "Confirm Merge",
      "DESCRIPTION": "Are you sure you want to merge this conversation? This action cannot be undone.",
      "YES": "Yes, Merge",
      "CANCEL": "Cancel"
    }
  }
}
